import {
    Box,
    Button,
    Flex,
    IconButton,
    Input,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Spinner,
    Text,
    useDisclosure,
    FormControl,
    FormLabel,
  } from '@chakra-ui/react'
  import React, { useState } from 'react'
  import { FaChevronDown, FaSearch, FaTimes } from 'react-icons/fa'
  import { LABEL, MESSAGE } from '../../../../constants'
  
  const ProjectsDropDown = ({ value, onChange, projects, loading }) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [searchTerm, setSearchTerm] = useState('')
  
    const handleSearchChange = (event) => {
      setSearchTerm(event.target.value)
    }
  
    const filteredProjects = projects.filter((project) => {
      const query = searchTerm.toLowerCase()
      return (
        (project.code || '').toLowerCase().includes(query) ||
        (project.name || '').toLowerCase().includes(query)
      )
    })
  
    const selectedProject = projects.find((project) => project.code === value)
    const selectedLabel = selectedProject
      ? `${selectedProject.code} - ${selectedProject.name}`
      : LABEL.PROJECTS_DROPDOWN.placeholder
  
    const handleSelectItem = (project) => {
      onChange(project.code)
      setSearchTerm('')
      onClose()
    }
  
    const handleClearSelection = (e) => {
      e.stopPropagation()
      onChange('')
    }
  
    return (
      <FormControl>
        <FormLabel textColor="gray.500" mb="0" fontSize="sm">
          {LABEL.PROJECTS_DROPDOWN.label}
        </FormLabel>
        <Menu isOpen={isOpen} onOpen={onOpen} onClose={onClose} closeOnSelect={false}>
          <Flex align="center" width="100%">
            <MenuButton
              as={Button}
              variant="outline"
              textColor="black"
              fontSize="sm"
              size="sm"
              width="100%"
              textAlign="left"
              fontWeight="light"
              rightIcon={<FaChevronDown />}
              border='1px' 
              borderColor='black'
            >
              {selectedLabel}
            </MenuButton>
            {value && (
              <IconButton
                icon={<FaTimes />}
                size="sm"
                ml={2}
                aria-label={LABEL.CLEAR_SELECTION.label}
                onClick={handleClearSelection}
              />
            )}
          </Flex>
          <MenuList width="600px" p="0">
            <Box
              position="sticky"
              top="0"
              bg="white"
              zIndex="1"
              p="2"
              borderBottom="1px solid"
              borderColor="gray.200"
            >
              <Flex align="center">
                <FaSearch style={{ marginRight: '6px', color: '#718096' }} />
                <Input
                  placeholder={LABEL.SEARCH.label}
                  size="sm"
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </Flex>
            </Box>
            <Box maxHeight="300px" overflowY="auto">
              {loading ? (
                <Box textAlign="center" p="2" width="600px" height="200px">
                  <Spinner size="sm" />
                </Box>
              ) : (
                <>
                  {filteredProjects.length === 0 ? (
                    <Box textAlign="center" p="2">
                      <Text fontSize="sm" color="gray.500">
                        {MESSAGE.NO_ELEMENT_FOUND.label}
                      </Text>
                    </Box>
                  ) : (
                    filteredProjects.map((project, index) => (
                      <MenuItem
                        key={index}
                        onClick={() => handleSelectItem(project)}
                        fontSize="sm"
                      >
                        {project.code} - {project.name}
                      </MenuItem>
                    ))
                  )}
                </>
              )}
            </Box>
          </MenuList>
        </Menu>
      </FormControl>
    )
  }
  
  export default ProjectsDropDown
  